import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var Contrast03 = function Contrast03(props) {
  return /*#__PURE__*/_jsxs("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: [/*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M12 22c5.5228 0 10-4.4772 10-10S17.5228 2 12 2 2 6.4772 2 12s4.4772 10 10 10"
    }), /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M16 8.5c0 4.1421-3.3579 7.5-7.5 7.5a7.52 7.52 0 0 1-1.7838-.2134C7.896 17.4297 9.823 18.5 12 18.5c3.5899 0 6.5-2.9101 6.5-6.5 0-2.177-1.0703-4.1041-2.7134-5.2838A7.52 7.52 0 0 1 16 8.5"
    })]
  }));
};
export default Contrast03;